<template>
  <div>
    <vxe-grid ref="table-m1" v-bind="vxeOption">
      <!-- 表单（搜索条件或操作按钮） -->
      <template #form>
        <div class="clearfix screen-btns">
          <div class="fl">
            <vxe-button
              status="primary"
              class="button-sty"
              icon="el-icon-upload2"
              @click="$refs.excelUpload.show()"
            >
              导入
            </vxe-button>
            <!-- <vxe-button status="primary" class="button-sty" icon="el-icon-download" @click="importExcel">导入</vxe-button> -->
          </div>
          <div class="fr">
            <vxe-button
              icon="el-icon-brush"
              class="button-sty"
              @click="resetEvent"
              type="text"
              status="primary"
              plain
              >重置</vxe-button
            >
            <vxe-button
              status="warning"
              icon="el-icon-search"
              class="button-sty"
              @click="searchEvent"
              >搜索</vxe-button
            >
          </div>
        </div>
      </template>
      <!-- 分页 -->
      <template #pager>
        <pager
          ref="pager"
          :page-sizes="pageSizes"
          @changeTablePage="changeTablePage"
        ></pager>
      </template>

      <!-- 行项目 -->
      <template #option> </template>
    </vxe-grid>

    <!--excel 模板导入 -->
    <excel-upload
      ref="excelUpload"
      title="平台数据导入"
      url="/basic/eBusinessData/jdInstallEvaluate/import"
      @refreshDataList="refreshChange"
    ></excel-upload>
  </div>
</template>

<script>
import { JDInstallEvaluateColumns } from "@/views/workorder/ebusiness/ebusinessImport/option/tableColumns";
import ExcelUpload from "@/components/upload/excel";
import pager from "@/components/pager/index.vue";
import { initVxeTable } from "@/const/crud/admin/table";
export default {
  components: {
    pager,
    ExcelUpload,
  },
  data() {
    return {
      total: 0,
      areaProps: {
        lazy: true,
        emitPath: false,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad,
      },
      orderDealType: "",
      showSiteOrderComplaintHandlingDialog: false,
      rowData: null,
      //权限管理
      orderEdit: false,
      assignSite: false,
      orderClose: false,
      orderFollowUp: false,
      areaObj: null,
      eBusinessTypes: [],
      assignAgain: false,
      requestParam: {
        searchCount: false, // 是否分页
        current: 1, // 当前页面
        size: 0, // 页面数据量
      },
      formData: {},
      enableStat: false,

      dataId: 0,
      vxeOption: {},
      // 查询参数
      pageSizes: [10, 20, 100],
      showEdit: false,
      tableData: [],
      columns: [],
    };
  },
  watch: {
    total(newVal) {
      // console.log("总数")
      this.$refs.pager.tableDataTotal = newVal
    },
  },
  methods: {
    flushed() {
			this.$refs['table-m1'].commitProxy('reload');
		},
    searchEvent() {
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },
    changeTablePage(page, flag) {
      console.log("分页查询");
      this.requestParam.size = page.pageSize;
      this.requestParam.current = page.currentPage;
      this.requestParam.searchCount = flag;
      this.getTableData();
    },
    async getTableData() {
      //   await this.loadTabOption();
      this.requestParam.pageType = "";
      let tableOption = {
        vue: this,
        tableRef: "table-m1",
        path: "/basic/eBusinessData/jdInstallEvaluate/getListPage",
        param: this.requestParam,
        method: "post",
        columns: JDInstallEvaluateColumns,
      };

      this.vxeOption = initVxeTable(tableOption);
      this.flushed();
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss"></style>
